export const services = [
    {
        id: 'electrical',
        title: 'ELECTRICAL WORK',
        titleJa: '電気設備',
        description: '屋内外配線・幹線・照明等、建物の電気設備工事を承ります。多数の現場経験から得た知識とノウハウで、安全かつ効率的な電気設備を提供します。',
        image: '/images/services/electrical.webp',
    },
    {
        id: 'piping',
        title: 'PIPING & HVAC',
        titleJa: '空調／衛生設備',
        description: '空調設備、衛生設備、消火配管など、配管工事全般を手がけます。快適な室内環境づくりから安全対策まで、ワンストップで対応可能です。',
        image: '/images/services/piping.webp',
    },
    {
        id: 'solar',
        title: 'SOLAR PV SYSTEM',
        titleJa: '太陽光発電',
        description: '産業用太陽光発電の設計・施工を行います。再生可能エネルギーの導入で、環境にやさしく、かつコスト削減にも貢献する発電システムを提案します。',
        image: '/images/services/solar.webp',
    },
];
